/**
 * The Firestore and Auth SDKs of the bid chat (#47189), loaded on first use instead of in the initial
 * bundle: fleet and organization users never download them. One shared load per SDK.
 */
export type FirestoreSdk = typeof import('firebase/firestore');
export type AuthSdk = typeof import('firebase/auth');

let firestoreSdk: Promise<FirestoreSdk> | null = null;
let authSdk: Promise<AuthSdk> | null = null;

/** A failed load (e.g. offline) is not cached, so the next call tries again. */
const once = <T>(load: () => Promise<T>, reset: () => void): Promise<T> =>
  load().catch((error) => {
    reset();
    throw error;
  });

export const loadFirestoreSdk = (): Promise<FirestoreSdk> =>
  (firestoreSdk ||= once(() => import('firebase/firestore'), () => (firestoreSdk = null)));

export const loadAuthSdk = (): Promise<AuthSdk> => (authSdk ||= once(() => import('firebase/auth'), () => (authSdk = null)));

/** Whether the Auth SDK was loaded (or is loading) in this page, i.e. a Firebase session can exist here. */
export const isAuthSdkLoaded = (): boolean => authSdk !== null;
